import { render, staticRenderFns } from "./InvocationGraph.vue?vue&type=template&id=fca89d36&scoped=true"
import script from "./InvocationGraph.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvocationGraph.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InvocationGraph.vue?vue&type=style&index=0&id=fca89d36&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca89d36",
  null
  
)

export default component.exports